import { AbstractCalendarHeadingController } from '../../generated/calendar-heading'
import { DAYS_OF_WEEK } from '../../lib'

export default AbstractCalendarHeadingController

/** @constructor @extends {AbstractCalendarHeadingController} @suppress {checkTypes} */ function _CalendarHeadingController() {}
AbstractCalendarHeadingController.__implement(
 _CalendarHeadingController.prototype = /** @type {!AbstractCalendarHeadingController} */ ({
  paint() {
   let{state:{headings},props:{i=0}}=this
   if (!headings) headings = DAYS_OF_WEEK
   const he = headings[i]
   this.innerHTML = he
  },
 }),
)
